(function () {
  function start() {
    var root = document.querySelector('[data-ns-native-promo]');
    if (!root || root.__nsNativePromo) return;
    root.__nsNativePromo = true;

    var modal = root.querySelector('[data-ns-native-promo-modal]');
    var dialog = root.querySelector('.ns-b1g2-dialog');
    var gift = root.querySelector('[data-ns-native-promo-gift]');
    var confirmButton = root.querySelector('[data-ns-native-promo-confirm]');
    var skipButton = root.querySelector('[data-ns-native-promo-skip]');
    var errorBox = root.querySelector('[data-ns-native-promo-error]');
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ns-native-promo-close]'));
    var code = root.dataset.discountCode;
    var promoKey = root.dataset.promoKey;
    var label = root.dataset.offerLabel || code;
    var cartUrl = root.dataset.cartUrl || '/cart';
    var pendingForm = null;
    var pendingExtras = [];
    var lastFocused = null;
    var busy = false;
    var claimed = false;
    var dismissalKey = 'ns_native_promo_dismissed_' + promoKey;

    function routesRoot() { return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'; }
    function requestJson(url, options) {
      return fetch(url, options).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (!response.ok) throw new Error(payload.description || payload.message || 'The cart could not be updated.');
          return payload;
        });
      });
    }
    function wait(ms) { return new Promise(function (resolve) { window.setTimeout(resolve, ms); }); }
    function setError(message) { errorBox.textContent = message || ''; errorBox.hidden = !message; }
    function mainForm() {
      var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
      return forms.find(function (form) { return String(form.id || '').indexOf('product-form-main-') === 0; }) ||
        forms.find(function (form) { return !form.closest('[id*="quick-buy"], quick-buy-modal, .quick-buy-modal'); }) || null;
    }
    function isMainForm(form) { return !!form && form === mainForm(); }
    function formItem(form, token) {
      var data = new FormData(form);
      var id = Number(data.get('id'));
      var quantity = Math.max(1, Number(data.get('quantity') || 1));
      if (!id) throw new Error('Please select an available product option first.');
      var properties = {};
      data.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') properties[match[1]] = value;
      });
      if (token) {
        properties['_NS promotion offer'] = 'true';
        properties['_NS promotion bundle'] = token;
        properties['_NS promotion key'] = promoKey;
      }
      var item = { id: id, quantity: quantity };
      if (Object.keys(properties).length) item.properties = properties;
      var sellingPlan = data.get('selling_plan');
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      return item;
    }
    function giftItem(token) {
      return { id: Number(gift.dataset.variantId), quantity: 1, properties: {
        '_NS promotion gift': 'true', '_NS promotion bundle': token, '_NS promotion key': promoKey
      }};
    }
    function safeExtras(extras) {
      return (extras || []).filter(function (item) { return item && Number(item.id); }).map(function (item) {
        var next = { id: Number(item.id), quantity: Math.max(1, Number(item.quantity || 1)) };
        if (item.properties && typeof item.properties === 'object') next.properties = item.properties;
        return next;
      });
    }
    function hasValidBundle(cart) {
      return (cart.items || []).some(function (item) {
        var props = item.properties || {};
        return props['_NS promotion offer'] === 'true' && props['_NS promotion key'] === promoKey;
      }) && (cart.items || []).some(function (item) {
        var props = item.properties || {};
        return props['_NS promotion gift'] === 'true' && props['_NS promotion key'] === promoKey && item.quantity === 1;
      });
    }
    function updateTrigger() {
      Array.prototype.slice.call(document.querySelectorAll('[data-ns-native-promo-open]')).forEach(function (button) {
        var copy = button.querySelector('[data-ns-native-promo-trigger-copy]');
        var action = button.querySelector('[data-ns-native-promo-trigger-action]');
        if (copy) copy.textContent = claimed ? 'Your gift is already in the cart' : 'See your included gift';
        if (action) action.textContent = claimed ? 'View cart' : 'View';
      });
    }
    function trigger() {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ns-b1g2-trigger';
      button.setAttribute('data-ns-native-promo-open', '');
      button.innerHTML = '<span class="ns-b1g2-trigger__mark" aria-hidden="true">FREE</span>' +
        '<span class="ns-b1g2-trigger__copy"><strong>' + escapeHtml(label) + '</strong><span data-ns-native-promo-trigger-copy>See your included gift</span></span>' +
        '<span class="ns-b1g2-trigger__action" data-ns-native-promo-trigger-action>View</span>';
      return button;
    }
    function escapeHtml(value) { var div = document.createElement('div'); div.textContent = value; return div.innerHTML; }
    function ensureTrigger() {
      var form = mainForm();
      if (!form || form.querySelector('[data-ns-native-promo-open]')) return;
      var buttons = form.querySelector('.product-info__buy-buttons, .product-form__buy-buttons') || form.closest('.product-info__buy-buttons, .product-form__buy-buttons');
      if (!buttons) return;
      buttons.insertAdjacentElement('beforebegin', trigger());
      updateTrigger();
    }
    function open(form, extras) {
      pendingForm = form || mainForm();
      pendingExtras = safeExtras(extras);
      lastFocused = document.activeElement;
      setError('');
      modal.hidden = false;
      document.body.classList.add('ns-b1g2-modal-open');
      window.requestAnimationFrame(function () { dialog.focus(); });
    }
    function close() {
      if (busy) return;
      try { sessionStorage.setItem(dismissalKey, String(Date.now())); } catch (error) {}
      modal.hidden = true;
      document.body.classList.remove('ns-b1g2-modal-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }
    function dismissedRecently() {
      try { return Date.now() - Number(sessionStorage.getItem(dismissalKey) || 0) < 60000; } catch (error) { return false; }
    }
    function removeBundle(cart, token) {
      var updates = {};
      (cart.items || []).forEach(function (item) {
        if (item.properties && item.properties['_NS promotion bundle'] === token) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return Promise.resolve();
      return requestJson(routesRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) }).catch(function () {});
    }
    function verify(cart, token) {
      var items = (cart.items || []).filter(function (item) { return item.properties && item.properties['_NS promotion bundle'] === token; });
      var offer = items.some(function (item) { return item.properties['_NS promotion offer'] === 'true'; });
      var gifts = items.filter(function (item) { return item.properties['_NS promotion gift'] === 'true'; });
      return offer && gifts.length === 1 && gifts[0].original_line_price > 0 && gifts[0].final_line_price === 0;
    }
    function discountCodes(cart) {
      var values = [];
      (cart.discount_codes || []).forEach(function (discount) {
        var value = String(discount && discount.code || '').trim();
        if (value && values.indexOf(value) === -1) values.push(value);
      });
      if (code && values.indexOf(code) === -1) values.push(code);
      return values;
    }
    function applyAndVerify(token, tries, codes) {
      if (!codes) {
        return requestJson(routesRoot() + 'cart.js').then(function (cart) {
          return applyAndVerify(token, tries, discountCodes(cart));
        });
      }
      return requestJson(routesRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) })
        .then(function () { return wait(300); })
        .then(function () { return requestJson(routesRoot() + 'cart.js'); })
        .then(function (cart) {
          if (verify(cart, token)) return cart;
          if (tries > 1) return wait(400).then(function () { return applyAndVerify(token, tries - 1, codes); });
          var error = new Error('The promotion could not be confirmed. Your cart has not been changed. Please try again.');
          error.cart = cart;
          throw error;
        });
    }
    function addProductOnly(form, extras) {
      if (busy) return;
      busy = true;
      setError('');
      var items;
      try { items = [formItem(form, null)].concat(safeExtras(extras)); } catch (error) { busy = false; setError(error.message); return; }
      requestJson(routesRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { window.location.assign(cartUrl); })
        .catch(function (error) { busy = false; setError(error.message || 'The product could not be added. Please try again.'); });
    }
    function addPromotion(form, extras) {
      if (busy) return;
      busy = true;
      setError('');
      var token = 'ns-' + promoKey + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var items;
      try { items = [formItem(form, token), giftItem(token)].concat(safeExtras(extras)); } catch (error) { busy = false; setError(error.message); return; }
      confirmButton.disabled = true;
      requestJson(routesRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { return applyAndVerify(token, 3); })
        .then(function () { window.location.assign(cartUrl); })
        .catch(function (error) {
          var cartPromise = error.cart ? Promise.resolve(error.cart) : requestJson(routesRoot() + 'cart.js');
          cartPromise.then(function (cart) { return removeBundle(cart, token); }).finally(function () {
            busy = false;
            confirmButton.disabled = false;
            setError(error.message || 'The promotion could not be added. Please try again.');
          });
        });
    }
    function startPromotion(form, extras) {
      if (!form) { setError('The product form could not be found. Please refresh and try again.'); return; }
      if (claimed || dismissedRecently()) addProductOnly(form, extras);
      else open(form, extras);
    }
    function loadClaimed() {
      requestJson(routesRoot() + 'cart.js').then(function (cart) { claimed = hasValidBundle(cart); updateTrigger(); }).catch(function () {});
    }
    closeButtons.forEach(function (button) { button.addEventListener('click', close); });
    confirmButton.addEventListener('click', function () { addPromotion(pendingForm || mainForm(), pendingExtras); });
    skipButton.addEventListener('click', function () { close(); addProductOnly(pendingForm || mainForm(), pendingExtras); });
    window.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-ns-native-promo-open]');
      if (openButton) { event.preventDefault(); if (claimed) window.location.assign(cartUrl); else open(mainForm(), []); return; }
      var add = event.target.closest('button[data-action="add-to-cart"], input[data-action="add-to-cart"]');
      if (!add) return;
      var form = add.form || add.closest('form[action*="/cart/add"]');
      if (!isMainForm(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      startPromotion(form, []);
    }, true);
    document.addEventListener('submit', function (event) {
      if (!isMainForm(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      startPromotion(event.target, []);
    }, true);
    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button:not(:disabled), [href], input:not(:disabled), [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    window.NSNativePromo = { start: startPromotion };
    ensureTrigger();
    loadClaimed();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();